"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxwellBase = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const SpaceName_1 = require("../../SpaceName");
const SpaceType_1 = require("../../SpaceType");
const Resources_1 = require("../../Resources");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
class MaxwellBase extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.MAXWELL_BASE,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.VENUS],
            cost: 18,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.venus(12)),
            metadata: {
                cardNumber: '238',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 resource to ANOTHER VENUS CARD.', (eb) => {
                        eb.empty().startAction.wild(1).secondaryTag(Tags_1.Tags.VENUS);
                    }).br;
                    b.production((pb) => pb.minus().energy(1)).nbsp().city().asterix();
                }),
                description: {
                    text: 'Requires Venus 12%. Decrease your energy production 1 step. Place a City tile ON THE RESERVED AREA.',
                    align: 'left',
                },
                victoryPoints: 3,
            },
        });
    }
    ;
    canPlay(player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1 && super.canPlay(player);
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.game.addCityTile(player, SpaceName_1.SpaceName.MAXWELL_BASE, SpaceType_1.SpaceType.COLONY);
        return undefined;
    }
    getVictoryPoints() {
        return 3;
    }
    getResCards(player) {
        return player.getResourceCards().filter((card) => card.tags.includes(Tags_1.Tags.VENUS) || card.tags.includes(Tags_1.Tags.WILDCARD));
    }
    canAct(player) {
        return this.getResCards(player).length > 0;
    }
    action(player) {
        const cards = this.getResCards(player);
        if (cards.length === 1) {
            player.addResourceTo(cards[0], { log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select card to add 1 resource', 'Add resource', cards, (foundCards) => {
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
    }
}
exports.MaxwellBase = MaxwellBase;
//# sourceMappingURL=MaxwellBase.js.map